import {
  CREATED_NEW_VENDOR,
  DOES_VENDOR_EXIST, SET_SELECTED_VENDOR, UPDATE_ALL_VENDORS, UPDATE_VENDOR_CONTACTS, VENDOR_DELETED,
  VENDOR_UPDATED
} from "../actions";

const vendorsReducer = (
  state = {
    // initial state
    allVendors: [],
    vendors: [],
    vendorContacts: [],
    newVendorCreated: false,
    vendorExists: { status: false },
    selectedVendor: null,
    vendorUpdated: false,
    vendorDeleted: false,
  },
  action
) => {
  switch (action.type) {
    case UPDATE_ALL_VENDORS:
      return {
        ...state,
        vendors: [...action.vendors],
        newVendorCreated: false,
        vendorUpdated: false,
        vendorDeleted: false,
      };

    case DOES_VENDOR_EXIST:
      return {
        ...state,
        vendorExists: { status: action.status },
      };

    case CREATED_NEW_VENDOR:
      return {
        ...state,
        newVendorCreated: true,
        selectedVendor: { ...action.vendor },
      };
    case SET_SELECTED_VENDOR:
      return {
        ...state,
        selectedVendor: { ...action.vendor },
      };

    case VENDOR_UPDATED:
      return {
        ...state,
        vendorUpdated: true,
      };
    case VENDOR_DELETED:
      return {
        ...state,
        vendorDeleted: true,
      };
    case UPDATE_VENDOR_CONTACTS:
      return {
        ...state,
        vendorContacts: [...action.vendorContacts],
      };

    default:
      return state;
  }
};

export default vendorsReducer;
